<script>
    let x = '<input type="text">';
</script>

<main>
    <div>
        {@html x}
    </div>
</main>

<style>

    main{
    display: flex;
    justify-content: center;
    }
    div{
        height: 200px;
        width: 200px;
        background-color: salmon;
    }

</style>